// extracted by mini-css-extract-plugin
export default {"expired":"dealDetail_expired__j88Fn"};